import { ApiKeyResponse, CreateApiKeyRequest } from "@/types/breeze/ApiKey";
import { BaseService } from "../BaseService";

export class ApiKeyService extends BaseService {
  public async getMyApiKeys(): Promise<ApiKeyResponse[]> {
    return this.getRequest("/api-keys");
  }

  public async createApiKey(
    request: CreateApiKeyRequest,
  ): Promise<ApiKeyResponse> {
    return this.postRequest(
      "/api-keys",
      request,
      "API key created successfully",
    );
  }

  public async revokeApiKey(id: string): Promise<void> {
    return this.deleteRequest(
      `/api-keys/${id}`,
      "API key revoked successfully",
    );
  }
}

export const apiKeyService = new ApiKeyService();
